import {
    Button,
    Link,
    SimpleText,
    useAppContext,
    useStaticUrls,
    showIntlMessageNotification,
    SimpleCallback,
    useGeneratePath,
} from 'platform-components';
import { GRAVITIES, NOTIFICATION_THEMES } from 'platform-components/constants';
import { copyTextToClipboard } from 'platform-components/utils';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { COMMON_NOTIFICATION_DELAY } from 'common.components/constants';
import * as lessonSelectors from 'common.components/lesson/selectors';

import { SidePanelControlTypeProps } from '../typings';

interface Props extends SidePanelControlTypeProps {
    canCopyLinkCm: boolean;
    onCopyLink: SimpleCallback;
}

export const SidePanelControlsTypeCopyLinkCm = React.memo(
    ({ notifyCanBeRender, notifyCanNotBeRender, canCopyLinkCm, onCopyLink }: Props) => {
        const dispatch = useDispatch();
        const { prefix, basePath } = useAppContext();
        const { labClassLessons } = useStaticUrls();
        const getRouterPath = useGeneratePath();
        const cLessonId = useSelector(lessonSelectors.getCLessonId);

        if (!canCopyLinkCm) {
            notifyCanNotBeRender();
            return null;
        }

        notifyCanBeRender();

        const copyLessonLinkCM = () => {
            const path = getRouterPath(labClassLessons);
            const link = `${basePath}${prefix}${path}?lessonId=${cLessonId}`;

            copyTextToClipboard(link);
            dispatch(
                showIntlMessageNotification({
                    closeDelay: COMMON_NOTIFICATION_DELAY,
                    gravity: GRAVITIES.BOTTOM,
                    messageId: 'toast.lesson.lessonLinkCopied',
                    theme: NOTIFICATION_THEMES.TOAST,
                })
            );

            onCopyLink();
        };

        return (
            <Link key="copyLessonLinkCM" mix="qa_copy-lesson-link-cm" onClick={copyLessonLinkCM} pseudo>
                <Button accent={Button.ACCENT.NORMAL} view={Button.VIEW.CLEAR}>
                    <SimpleText id="lessonEditor.copyLessonLink" />
                </Button>
            </Link>
        );
    }
);
